export function removeTypename(target: any) {
  if (typeof target === 'object') {
    for (const key in target) {
      if (key === '__typename') {
        delete target[key];
      } else {
        removeTypename(target[key]);
      }
    }
  }
}

// A round function that rounds towards even numbers when the fractional part is
// 0.5. This is the default behavior in most other languages, like C# and Java,
// with which our backend is written. As such, it is desirable to have the same
// behavior in JavaScript too.
//
// The JS Math.round function always rounds towards positive infinity.
export function saneRound(n: number) {
  const frac = Math.abs(n % 1);
  if (frac !== 0.5)
    return Math.round(n);

  const ceil = Math.ceil(n);
  if (ceil % 2 === 0)
    return ceil;

  return Math.floor(n);
}
